import { render, staticRenderFns } from "./IconFeedback.vue?vue&type=template&id=3f792082&functional=true&"
import script from "./IconFeedback.vue?vue&type=script&lang=ts&"
export * from "./IconFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports